import { useTranslation } from 'react-i18next';
import Alert from '../../styled-components/components/Alert';
import Container from '../../styled-components/components/Container';
import { PageSection } from '../../styled-components/components/PageSection';
import PageHeader from '../../styled-components/structures/PageHeader';

const NotFound = () => {
  const { t } = useTranslation(['activity', 'other']);

  return (
    <Container>
      <PageHeader
        heading={t('pageNotFound.heading', { ns: 'other' })}
        preamble={<p>{t('pageNotFound.description', { ns: 'other' })}</p>}
        breadcrumbs={[
          {
            displayName: t('activity', { ns: 'activity' }),
            link: {
              to: '/',
              title: t('activity', { ns: 'activity' }),
            },
          },
          {
            displayName: t('pageNotFound.heading', { ns: 'other' }),
          },
        ]}
      />
      <PageSection>
        <Alert
          tone="error"
          heading={t('pageNotFound.alertHeading', { ns: 'other' }) || undefined}
          message={t('pageNotFound.alertMessage', { ns: 'other' })}
        />
      </PageSection>
    </Container>
  );
};

export default NotFound;
